module.exports = __webpack_public_path__ + "static/media/sushiswap.414544cc.avif";